import type { MarketItem, MarketRelease, ProtoInt64 } from '@/types';

function int64Value(value: ProtoInt64): bigint {
  try {
    return BigInt(value);
  } catch {
    return 0n;
  }
}

function compareReleaseOrder(left: MarketRelease, right: MarketRelease) {
  const publishedAtDifference =
    int64Value(left.publishedAtMs) - int64Value(right.publishedAtMs);
  if (publishedAtDifference !== 0n) {
    return publishedAtDifference > 0n ? 1 : -1;
  }

  const releaseIdDifference =
    int64Value(left.releaseId) - int64Value(right.releaseId);
  if (releaseIdDifference === 0n) {
    return 0;
  }
  return releaseIdDifference > 0n ? 1 : -1;
}

export function findNewerAvailableRelease(
  item: MarketItem,
): MarketRelease | undefined {
  if (!item.activeVersion || !item.latestAvailableRelease) {
    return undefined;
  }

  const activeRelease = item.activeRelease;
  if (!activeRelease) {
    return undefined;
  }

  const latest = item.latestAvailableRelease;
  return latest.status === 'available' &&
    latest.version !== item.activeVersion &&
    compareReleaseOrder(latest, activeRelease) > 0
    ? latest
    : undefined;
}
